import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagRO(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURf/YT9EYL9oeNf7VRP3SO+IjOgQvgQYziQc2kAg5lQk7mj9haAMAAAGtSURBVDjL3Y8xjqMwGIUt+QLgE8SW6C3ZN4ADREi5QQQHSGRSRkoR6KaMqaZlT7nvmYQhq2Xq0Tz8O8X3+dkRf5Z8iiWHJXvxE4QRaMQ3TRvCxIxjHLeEkTDGaYof/xdinI04bQop3zW8shLquj4UB0y9IRRkafbiEQck4ue94Zm9GB5gD2S4Cjtja+uiMKAFr+iHoX+wpL9aKa2TUgpJXCCm2ImhB+8pXa21UnCzpjCmNph6J8B7cIQCC6RFw3yHMbhiyS3V03LpeMpuLeAFgNIJ+8L1u8ALnEwN5qvh3l8u95SbczzvULMWQKH02G58o+Nf/bcBpzvsqSFFvjVcLt09zWkRnFFfQkeW1lrQiFFIJu5dCoyVoFmhudCQTtNZC4hSXBReOZXelR5TloocWL8LM/doICPWOlsJZ+/n81WZ61zpXKucDaFrQ4c9nMpXPAjvgJKJtqUBpT3zfMWpwHMEFZkICI0Qzh7IeyxPSIcNXZtoCO0xcT6hQjkchcEVQE1okSPIM/mSTDRNIG5CkxoqFsyCmoW2abCQcKyqjQYqAQ0bQmie2Wz4BcJfLHiS3dqtFIsAAAAASUVORK5CYII=",
    alt: "RO"
  }, props));
}